import { gql } from '@apollo/client';

export const CREATE_DOCUMENT = gql`
  mutation CreateChatbotDocument($params: CreateDocumentInput) {
    createChatbotDocument(params: $params) {
      success
      message
      errors
      data {
        id
        tenantId
        userId
        fileName
        originalFileName
        fileSize
        mimeType
        path
        uri
        description
        tags
        docMetadata
        documentTypeId
        documentType {
          id
          code
          name
          description
          chunkSize
          chunkOverlap
          createdAt
          createdBy
        }
        createdAt
        createdBy
      }
    }
  }
`;

export const UPDATE_DOCUMENT = gql`
  mutation UpdateChatbotDocument($params: UpdateDocumentInput) {
    updateChatbotDocument(params: $params) {
      success
      message
      errors
      data {
        id
        tenantId
        userId
        fileName
        originalFileName
        fileSize
        mimeType
        path
        uri
        description
        tags
        docMetadata
        documentTypeId
        documentType {
          id
          code
          name
          description
          chunkSize
          chunkOverlap
          createdAt
          createdBy
        }
        createdAt
        createdBy
      }
    }
  }
`;

export const DELETE_DOCUMENT = gql`
  mutation DeleteChatbotDocument($params: DeleteDocumentInput) {
    deleteChatbotDocument(params: $params) {
      success
      message
      errors
    }
  }
`;
